import Menu from './menu';
import MenuItem from './menu-item';
import SubMenu from './sub-menu';
import MenuItemGroup from './menu-item-group';
import MenuDivider from './menu-divider';
var DefaultMenu = Menu;
DefaultMenu.Item = MenuItem;
DefaultMenu.SubMenu = SubMenu;
DefaultMenu.ItemGroup = MenuItemGroup;
DefaultMenu.Divider = MenuDivider;
export default DefaultMenu;
//# sourceMappingURL=index.js.map